import SvgIcon from '../../SvgIcon/SvgIcon';
import SupplierRegistrationPopup from '../../Supplier/SupplierRegistrationPopup';
import { useSupplier } from '../../../hooks/useSupplier';

interface Props {
  onSupplierCreated?: () => Promise<void> | void;
  onReload?: () => void;
  message?: string;
}

const QuickAddSupplier: React.FC<Props> = ({
  onSupplierCreated,
  onReload,
  message = '¿No encuentras el proveedor? Puedes registrar uno nuevo.',
}) => {
  const { showRegistrationModal, openAddModal, closeAddModal } = useSupplier();

  return (
    <div
      className="
        mt-1 flex flex-col gap-2
        sm:flex-row sm:items-center sm:justify-between
      "
    >
      {/* Texto contextual */}
      <p className="text-gray-600 dark:text-gray-300 text-xs">{message}</p>

      {/* Contenedor botones */}
      <div className="flex items-center gap-2">
        {/* ✅ VERDE — Recargar */}
        <button
          onClick={onReload}
          type="button"
          className="
            inline-flex items-center gap-1 rounded
            bg-[#3CA745] px-2 py-1 text-xs font-medium text-white
            transition hover:bg-opacity-90
          "
        >
          <SvgIcon name="refresh" className="h-3 w-3" />
          Recargar
        </button>

        {/* ✅ AZUL — Nuevo proveedor */}
        <button
          onClick={openAddModal}
          type="button"
          className="
            inline-flex items-center gap-1 rounded
            bg-primary px-2 py-1 text-xs font-medium text-white
            transition hover:bg-opacity-90
          "
        >
          <SvgIcon name="plus" className="h-3 w-3" />
          Nuevo
        </button>
      </div>

      {/* Modal */}
      <SupplierRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeAddModal}
        onSubmit={onSupplierCreated}
      />
    </div>
  );
};

export default QuickAddSupplier;
